export default "__VITE_ASSET__cb04a392__"